// extracted by mini-css-extract-plugin
module.exports = {"searchBar":"SearchBar_searchBar__17mc5","fondo":"SearchBar_fondo__uaiK2"};